export default [
  {
    path: '/lessons',
    name: 'lessons',
    component: () =>
      import(
        /* webpackChunkName: 'lessons' */
        '@/views/lessons/LessonsView'
      ),
    meta: { isTimeZoneSensitive: true },
  },
  {
    path: '/lessons/share-history',
    name: 'lessons.share_history',
    component: () =>
      import(
        /* webpackChunkName: 'share-history' */
        '@/views/share-history/ShareHistoryView'
      ),
    meta: { isTimeZoneSensitive: true },
  },
];
